import React, { useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Popover,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { colors } from "theme";
import { FilterBadgeWrapper } from "../styles";
import { CLAIMS_STATUS } from "../utils";
import { Ptag } from "components/core";

function FilterBar({filters, onChange}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterStatusSelected, setFilterStatusSelected] = useState(new Set([]));
  
  onChange(filterStatusSelected)
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const filterHandler = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCheckbox = (status) => {
    if (filterStatusSelected.has(status)) {
      setFilterStatusSelected((prev) => {
        prev.delete(status);
        return new Set(prev);
      });
    } else {
      setFilterStatusSelected((prev) => {
        prev.add(status);
        return new Set(prev);
      });
    }
  };
  const isChecked = (status) => {
    return filterStatusSelected.has(status);
  };
  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          style: {
            boxShadow: "none",
            border: `1px solid #D0D5DD`,
            borderRadius: "10px"
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <section>
          <FormControl
            style={{
              margin: "16px 24px",
            }}
            component="fieldset"
            variant="standard"
          >
            <FormGroup>
              {filters.map((status) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isChecked(status)}
                      onChange={() => handleCheckbox(status)}
                      name={status}
                      style={{
                        transform: "scale(1.4)",
                        color: colors.primaryColor
                      }}
                    />
                  }
                  label={<Ptag fontSize="12px">{status}</Ptag>}
                />
              ))}
            </FormGroup>
          </FormControl>
        </section>
      </Popover>
      <Button
        variant="contained"
        startIcon={<FilterListIcon color="black" />}
        onClick={filterHandler}
        sx={{
          backgroundColor: colors.whiteColor,
          fontSize: "14px",
          textTransform: "capitalize",
          fontFamily: "Inter",
          border: "1px solid #D0D5DD",
          color: "#344054",
          boxShadow: "0",
          borderRadius: "10px",
          "&:hover": {
            boxShadow: "0",
            backgroundColor: "white",
          },
        }}
      >
        Status
        {filterStatusSelected.size > 0 && (
          <FilterBadgeWrapper>
            <p>{filterStatusSelected.size}</p>
          </FilterBadgeWrapper>
        )}
      </Button>
    </>
  );
}

export default FilterBar;
